import request from './common/request'
import qs from 'qs'
import axios from 'axios'
import store from '@/store'

import { MERCHANT_GRADE_EXAMINEE_URI, MERCHANT_GRADE_PROJECT_URI } from './urls'

async function listExaminees (params) {
  return request(
    {
      url: `${MERCHANT_GRADE_EXAMINEE_URI}`,
      method: 'GET',
      params
    }
  )
}

async function getExamineeById (id) {
  return request(
    {
      url: `${MERCHANT_GRADE_EXAMINEE_URI}/${id}`,
      method: 'GET'
    }
  )
}

async function addExaminee (data) {
  return request(
    {
      url: MERCHANT_GRADE_EXAMINEE_URI,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateExaminee (data) {
  return request(
    {
      url: `${MERCHANT_GRADE_EXAMINEE_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function uploadExaminees (forms) {
  const result = await axios.post(`${process.env.BASE_API}${MERCHANT_GRADE_EXAMINEE_URI}/upload`, forms,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${store.state.MerchantAuth.accessToken}`
      }
    }
  )
  return result
}

async function listProjects (params) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}`,
      method: 'GET',
      params
    }
  )
}

async function allProjects () {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/all`,
      method: 'GET'
    }
  )
}

async function getProjectById (id) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${id}`,
      method: 'GET'
    }
  )
}

async function addProject (data) {
  return request(
    {
      url: MERCHANT_GRADE_PROJECT_URI,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateProject (data) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function listProjectLevels (projectId) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${projectId}/projectLevel`,
      method: 'GET'
    }
  )
}

async function getProjectLevelById (params) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${params.projectId}/projectLevel/${params.id}`,
      method: 'GET'
    }
  )
}

async function addProjectLevel (data) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${data.projectId}/projectLevel`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateProjectLevel (data) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${data.projectId}/projectLevel/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function listProjectExaminees (params) {
  return request(
    {
      url: `${MERCHANT_GRADE_PROJECT_URI}/${params.projectId}/examinee`,
      method: 'GET',
      params
    }
  )
}

async function listProjectExamineesByExamineeId (examineeId) {
  return request(
    {
      url: `${MERCHANT_GRADE_EXAMINEE_URI}/${examineeId}/projectExaminee`,
      method: 'GET'
    }
  )
}
async function submitExamineeProjectLevel (data) {
  return request(
    {
      url: `${MERCHANT_GRADE_EXAMINEE_URI}/${data.examineeId}/projects/${data.projectId}/projectLevels`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

export default {
  listExaminees,
  getExamineeById,
  addExaminee,
  updateExaminee,
  uploadExaminees,
  listProjects,
  allProjects,
  getProjectById,
  addProject,
  updateProject,
  listProjectLevels,
  getProjectLevelById,
  addProjectLevel,
  updateProjectLevel,
  listProjectExaminees,
  listProjectExamineesByExamineeId,
  submitExamineeProjectLevel
}



// WEBPACK FOOTER //
// ./src/api/merchant-grade.js